<ng-template #container> </ng-template>